import { Row } from '../common/forms/layout.js';
import { Column2 } from '../common/forms/layout.js';
import { Column3 } from '../common/forms/layout.js';
import { Column4 } from '../common/forms/layout.js';
import { Column5 } from '../common/forms/layout.js';
import { Column6 } from '../common/forms/layout.js';
import { Column8 } from '../common/forms/layout.js';
import { Column9 } from '../common/forms/layout.js';
import { Column12 } from '../common/forms/layout.js';

const fields = {
    ordinacija: {
        key: 'ordinacija',
        type: 'uiSelect',
        templateOptions: {
            label: 'Ordinacija',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite ordinaciju',
            options: [],
            required: true
        },
        controller: [
            '$scope',
            'DS',
            function($scope, DS) {
                DS.findAll('Ordinacija').then(function(response) {
                    $scope.to.options = response;
                });
            }
        ]
    },
    datum_naloga: {
        key: 'datum_naloga',
        type: 'datepicker',
        templateOptions: {
            label: 'Datum naloga'
        }
    },
    pacijent: {
        key: 'pacijent',
        type: 'input',
        templateOptions: {
            required: true,
            label: 'Pacijent',
            focus: true
        }
    },
    spol: {
        key: 'spol',
        type: 'uiSelect',
        templateOptions: {
            required: true,
            label: 'Spol',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite spol',
            options: [{ id: 'M', naziv: 'M' }, { id: 'Ž', naziv: 'Ž' }]
        }
    },
    godina_rodjenja: {
        key: 'godina_rodjenja',
        type: 'input',
        templateOptions: {
            label: 'Godina rođenja',
            type: 'number'
        }
    },
    napomena: {
        key: 'napomena',
        type: 'textarea',
        templateOptions: {
            label: 'Napomena',
            rows: 4
        }
    },
    boja: {
        key: 'boja',
        type: 'uiSelect',
        templateOptions: {
            label: 'Boja',
            required: true,
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'naziv',
            labelProp: 'naziv',
            // placeholder: 'Odaberite boju',
            options: []
        },
        controller: [
            '$scope',
            'DS',
            function($scope, DS) {
                DS.findAll('Boja').then(function(response) {
                    $scope.to.options = response;
                });
            }
        ]
    },
    oznaka_boje: {
        key: 'oznaka_boje',
        type: 'uiSelect',
        templateOptions: {
            label: 'Oznaka',
            required: true,
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'oznaka',
            labelProp: 'oznaka',
            // placeholder: 'Odaberite oznaku',
            options: []
        },
        controller: [
            '$scope',
            'DS',
            function($scope, DS) {
                DS.findAll('OznakaBoje').then(function(response) {
                    $scope.to.options = response;
                });
            }
        ]
    },
    oblik: {
        key: 'oblik',
        type: 'uiSelect',
        templateOptions: {
            label: 'Oblik',
            required: true,
            optionsAttr: 'bs-options',
            valueProp: 'naziv',
            labelProp: 'naziv',
            // placeholder: 'Odaberite oznaku',
            options: [
                { id: '-', naziv: '-' },
                { id: 'Pravokutni', naziv: 'Pravokutni' },
                { id: 'Trokutasti', naziv: 'Trokutasti' },
                { id: 'Ovalni', naziv: 'Ovalni' },
                { id: 'Kockasti', naziv: 'Kockasti' }
            ]
        }
    }
};

export default function(ac, app) {
    var radniNalog = app.getEntity('RadniNalog');
    radniNalog
        .listView()
        .title('Pregled radnih naloga')
        .description('Evidencija zaprimljenih radnih naloga')
        .icon('<i class="fa fa-file-text-o fa-3x"></i>')
        .fields([
            ac
                .field('sifra_naloga', 'template')
                .label('Šifra naloga')
                .template(function(entry) {
                    return `${entry.sifra_naloga}`;
                }),
            ac.field('pacijent').cssClasses(function(entry) {
                return '';
            }),
            ac
                .field('ordinacija', 'reference')
                .targetEntity(app.getEntity('Ordinacija'))
                .targetField(ac.field('naziv'))
        ])
        .listActions(['edit']);

    radniNalog
        .creationView()
        .fields([
            [
                Row([Column4([fields.datum_naloga])]),
                Row([Column4([fields.pacijent]), Column4([fields.ordinacija])]),
                Row([Column4([fields.spol]), Column4([fields.godina_rodjenja])]),
            ],
            [Row([Column12([fields.boja]), Column12([fields.oznaka_boje]), Column12([fields.oblik])])],
            [Row([Column12([fields.napomena])])]
        ]);

    radniNalog
        .editionView()
        .fields([
            Row([Column4([fields.datum_naloga])]),
            Row([Column4([fields.pacijent]), Column4([fields.ordinacija])]),
            Row([Column4([fields.spol]), Column4([fields.godina_rodjenja])]),
            Row([Column3([fields.boja]), Column3([fields.oznaka_boje]), Column3([fields.oblik])]),
            Row([Column12([fields.napomena])])
        ]);

    return radniNalog;
}



// WEBPACK FOOTER //
// ./app/components/radniNalog/config.js